// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navPrincipal{\r\n    margin-left: 1200px;\r\n    background-color: blue;\r\n}\r\n\r\n.personas{\r\n    color: white;\r\n}", "",{"version":3,"sources":["webpack://./src/Persona.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".navPrincipal{\r\n    margin-left: 1200px;\r\n    background-color: blue;\r\n}\r\n\r\n.personas{\r\n    color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
